module.exports = __webpack_public_path__ + "static/media/step2b.9c822d09.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Tour/assets/step2b.png
// module id = 3735
// module chunks = 0